import { render, staticRenderFns } from "./learningCourses.vue?vue&type=template&id=37488495&scoped=true"
import script from "./learningCourses.vue?vue&type=script&lang=js"
export * from "./learningCourses.vue?vue&type=script&lang=js"
import style0 from "./learningCourses.vue?vue&type=style&index=0&id=37488495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37488495",
  null
  
)

export default component.exports